'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const omit = require('lodash.omit');
const connectToStores = require('fluxible-addons-react/connectToStores');
const FavoriteModel = require('bunsen/models/identity/Favorite');
const TYPE_SEARCH = FavoriteModel.TYPE_SEARCH;

const ContextComponent = require('../../../global/components/ContextComponent');
const SanitizeHtml = require('../../../global/components/SanitizeHtml');
const FavoritePageStore = require('../../../global/stores/FavoritePageStore');
const FavoriteButton = require('../../../components/FavoriteCta/FavoriteButton');
const StickyAlertMiddle = require('../../../components/StickyAlert/StickyAlertMiddle/StickyAlertMiddle');

const style = require('./SaveSearch.scss');

class SaveSearch extends ContextComponent {

    constructor(props) {
        super(props);

        this._onClick = this._onClick.bind(this);
        this._closeSuccessMessage = this._closeSuccessMessage.bind(this);

        this.state = {
            successMessageIsOpen: false,
            buttonClicked: false
        };
    }

    componentWillReceiveProps(nextProps) {
        // Should show success message components button was clicked, favorites were
        // fetched already and favorite was saved
        if (this.state.buttonClicked && this.props.isFetched && !this.props.isSaved && nextProps.isSaved) {
            this.setState({
                successMessageIsOpen: true,
                buttonClicked: false
            });

            // Close success message after 5 seconds
            setTimeout(this._closeSuccessMessage, 5000);
        }
    }

    _onClick() {
        this.setState({buttonClicked: true});
    }

    _closeSuccessMessage() {
        this.setState({successMessageIsOpen: false});
    }

    render() {
        const {successMessageIsOpen} = this.state;
        const allowedTags = ['div', 'a', 'span', 'br', 'p'];
        const allowedAttributes = {span: ['class']};
        const buttonClass = `${style.button} button-primary button-large`;
        const buttonData = omit(this.props, 'description', 'successMessage');

        return (
            <div>
                <div className={style.contentWrapper}>
                    <SanitizeHtml
                        allowedTags={allowedTags}
                        allowedAttributes={allowedAttributes}
                        content={this.props.description}
                    />
                </div>
                <FavoriteButton className={buttonClass} onClick={this._onClick} {...buttonData} />
                <StickyAlertMiddle isOpen={successMessageIsOpen} onClose={this._closeSuccessMessage}>
                    <SanitizeHtml allowedTags={allowedTags} content={this.props.successMessage} />
                </StickyAlertMiddle>
            </div>
        );
    }

}

SaveSearch.propTypes = {
    id: PropTypes.number,
    favoriteData: PropTypes.object.isRequired,
    cta: PropTypes.object.isRequired,
    tracking: PropTypes.object,
    successMessage: PropTypes.node,

    isSaved: PropTypes.bool,
    isFetched: PropTypes.bool,
    description: PropTypes.string
};

module.exports = connectToStores(
    SaveSearch,
    [
        FavoritePageStore
    ],
    context => {
        const store = context.getStore(FavoritePageStore);
        return {
            id: store.getFavoriteId(TYPE_SEARCH),
            isSaved: store.isSaved(TYPE_SEARCH),
            isFetched: store.isFetched(TYPE_SEARCH)
        };
    }
);



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/SaveSearch/SaveSearch.jsx